import UiDetail from "./UiDetail";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import { EnumPipe } from "@/models/EnumPipe";
import DtoDetailParamTransportRouteCode_ParamCarrier from "./DtoDetailParamTransportRouteCode_ParamCarrier";
import UiGroup from "./UiGroup";

/**
 * 航线代码详细
 * @description 自动生成的代码,请勿修改
 */
export default class DtoDetailParamTransportRouteCode extends UiDetail<string> {
    constructor() {
        //无参构造函数
        super()
    }

    [proName: string]: any;
    /**
     * 中文名称
     */
    NameZh?: string;
    /**
     * 英文名称
     */
    NameEn?: string;
    /**
     * 代码
     */
    Code?: string;
    /**
     * 全名
     */
    FullName?: string;
    /**
     * 承运人Id
     */
    ParamCarrierId?: string;
    /**
     * 承运人
     */
    ParamCarrier?: DtoDetailParamTransportRouteCode_ParamCarrier;
    /**
     * 备注
     */
    Remarks?: string;
}

/**
 * 航线代码详细-表单校验
 */
export const DtoDetailParamTransportRouteCodeRules = {
}

/**
 * 航线代码详细-设置项
 */
export const DtoDetailParamTransportRouteCodeMiezzDetailItems: MiezzFormItem[] = [
  {
    Prop: "NameZh",
    Label: "中文名称",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "NameEn",
    Label: "英文名称",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "Code",
    Label: "代码",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "FullName",
    Label: "全名",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "ParamCarrierId",
    Label: "承运人Id",
    Hide: true,
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "ParamCarrier",
    Label: "承运人",
    Customize: true,
  },
  {
    Prop: "Remarks",
    Label: "备注",
    Type: EnumMiezzFormItemType.Text,
  },
]
